<template>
    <div v-if="mostrarCalendario" class="fixed top-0 left-0 flex items-center justify-center w-full h-full z-50 bg-black bg-opacity-50">
        
        <div class="flex flex-col overflow-hidden bg-white rounded-2xl w-[460px] p-5 shadow-2xl">

            <div class="text-primary w-full">
                <DatePicker 
                    v-model="data"
                    locale="pt-br"
                    :model-config="modelConfig" 
                    :first-day-of-week="0"
                    expanded />
            </div>

            <div class="flex w-full gap-3 mt-4">
                <Button color="custom"
                        class="h-12 flex-1 text-white rounded-xl font-medium"
                        @click="hideCalendario()"
                >                                        
                    Cancelar
                </Button>
                <Button color="custom"
                        class="h-12 flex-1 text-white rounded-xl font-medium"
                        @click="$emit('consultarPeriodo')"
                >
                    Ok
                </Button>
            </div>
        </div>
    </div>
</template>
<script lang='ts'>
import {  ref, defineComponent, computed, watch } from 'vue';
import { DatePicker } from 'v-calendar';
import { Button } from '@/components';
import vmRelatorio from '@/ViewModel/ConsultaRelatorioViewModel';
import 'v-calendar/dist/style.css';

const Calendario = defineComponent({
    name: 'Calendario',
    components: {
        DatePicker,
        Button
    },
    emits: ['consultarPeriodo'],
      
    setup(){
        const mostrarCalendario = computed(() => vmRelatorio.exibirCalendario.mostrarCalendario);
        const data = ref( vmRelatorio.retornarData);
        const modelConfig = ref( { type: 'string',   mask: 'YYYY-MM-DD'    },  );  
        
       

        const hideCalendario = () => {
           
            vmRelatorio.exibirCalendario.mostrarCalendario = false;
        };


        
        watch(
            () => data.value,
            (count) => {
                vmRelatorio.retornarData(count.toString());
                let dataFormatoBr = vmRelatorio.retornarDataFormatada(count.toString());
                vmRelatorio.form.dtInicial = dataFormatoBr;
                vmRelatorio.form.dtFinal = dataFormatoBr;                
            }
        );


        return {
            data,
            modelConfig,
            mostrarCalendario,
            hideCalendario,
        };
    }
});
export default Calendario;
</script>
<style scoped>
:deep(.vc-container) {
  --vc-text-xs: 0.95rem;    
  --vc-text-sm: 1.1rem;     
  --vc-text-base: 1.3rem;   
  border: none !important;  
}

:deep(.vc-day-content) {
  width: 45px !important;
  height: 45px !important;
  font-size: 1.1rem !important;
}

:deep(.vc-arrow) {
  width: 36px !important;
  height: 36px !important;
}
</style>
